"use strict";
// Copyright 2019-2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var MeetingSessionStatusCode_1 = require("../meetingsession/MeetingSessionStatusCode");
var DefaultSDP_1 = require("../sdp/DefaultSDP");
var BaseTask_1 = require("./BaseTask");
/*
 * [[CreateSDPTask]] asynchronously calls [[createOffer]] on peer connection.
 */
var CreateSDPTask = /** @class */ (function (_super) {
    __extends(CreateSDPTask, _super);
    function CreateSDPTask(context) {
        var _this = _super.call(this, context.logger) || this;
        _this.context = context;
        _this.taskName = 'CreateSDPTask';
        return _this;
    }
    CreateSDPTask.prototype.cancel = function () {
        var error = new Error("canceling " + this.name());
        this.cancelPromise && this.cancelPromise(error);
    };
    CreateSDPTask.prototype.sessionUsesAudio = function () {
        return true;
    };
    CreateSDPTask.prototype.sessionUsesVideo = function () {
        var enabled = true;
        var sending;
        if (this.context.transceiverController.useTransceivers()) {
            sending = this.context.transceiverController.hasVideoInput();
        }
        else {
            sending = this.context.videoTileController.hasStartedLocalVideoTile();
        }
        var receiving = !!this.context.videosToReceive && !this.context.videosToReceive.empty();
        var usesVideo = enabled && (sending || receiving);
        this.context.logger.info("uses video: " + usesVideo + " (enabled: " + enabled + ", sending: " + sending + ", receiving: " + receiving + ")");
        return usesVideo;
    };
    CreateSDPTask.prototype.run = function () {
        return __awaiter(this, void 0, void 0, function () {
            var offerOptions;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        offerOptions = {
                            offerToReceiveAudio: this.sessionUsesAudio(),
                            offerToReceiveVideo: this.sessionUsesVideo(),
                        };
                        this.logger.info("peer connection offerOptions: " + JSON.stringify(offerOptions));
                        return [4 /*yield*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                                var _a, error, error_1;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            this.cancelPromise = function (error) {
                                                reject(error);
                                            };
                                            _b.label = 1;
                                        case 1:
                                            _b.trys.push([1, 3, , 4]);
                                            _a = this.context;
                                            return [4 /*yield*/, this.context.peer.createOffer(offerOptions)];
                                        case 2:
                                            _a.sdpOfferInit = _b.sent();
                                            this.context.logger.info('peer connection created offer');
                                            if (this.context.previousSdpOffer) {
                                                if (new DefaultSDP_1.default(this.context.sdpOfferInit.sdp).videoSendSectionHasDifferentSSRC(this.context.previousSdpOffer)) {
                                                    error = new Error("canceling " + this.name() + " due to the meeting status code: " + MeetingSessionStatusCode_1.default.IncompatibleSDP);
                                                    this.context.previousSdpOffer = null;
                                                    reject(error);
                                                }
                                            }
                                            resolve();
                                            return [3 /*break*/, 4];
                                        case 3:
                                            error_1 = _b.sent();
                                            reject(error_1);
                                            return [3 /*break*/, 4];
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return CreateSDPTask;
}(BaseTask_1.default));
exports.default = CreateSDPTask;
//# sourceMappingURL=CreateSDPTask.js.map